module.exports = __webpack_public_path__ + "assets/img/m702-badge-3.d9a537a8.png";